/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2017-2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.contentEditorModule')
  .directive('imageCarousel', [
    '$',
    '$compile',
    '$log',
    '$q',
    '$window',
    'Restangular',
    'BulbAssetLibraryService',
    'BulbAssetLibraryGoogleDriveService',
    'BulbAssetLibraryGooglePhotoService',
    'BulbAssetLibraryOneDriveService',
    'BulbAssetLibraryUnsplashService',
    'BulbAssetLibraryUploadService',
    'BulbBusyService', 'BulbBusyCoverService',
    'BulbModalService',
    'BulbPageService',
    'SerialSaveService',
    'UnitStateStore',
    'CONFIG',
    'CONTENT_EDITOR',
    'CKE_STATUS',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    imageCarousel,
  ]);

function imageCarousel(
  $,
  $compile,
  $log,
  $q,
  $window,
  Restangular,
  BulbAssetLibraryService,
  BulbAssetLibraryGoogleDriveService,
  BulbAssetLibraryGooglePhotoService,
  BulbAssetLibraryOneDriveService,
  BulbAssetLibraryUnsplashService,
  BulbAssetLibraryUploadService,
  BulbBusyService,
  BulbBusyCoverService,
  BulbModalService,
  BulbPageService,
  SerialSaveService,
  UnitStateStore,
  CONFIG,
  CONTENT_EDITOR,
  CKE_STATUS,
) {
  return {
    restrict: 'E',
    controller: 'ImageCarouselBlockController as imageCarouselBlockCtrl',
    templateUrl: 'ajs/components/contenteditor/imagecarouselblock.html',
    require: ['^?mediumContentEditor', '^contentBlock', '^imageCarousel'],
    link(scope, element, attrs, ctrls) {
      const that = this;

      // We could upgrade this directive to a pure Angular directive, which would be better, however the time to
      // refactor this directive would outweigh any cost ( at the moment -- we are going to have to do this at some
      // point ).
      // eslint-disable-next-line no-param-reassign
      $window.bulbVars.ImageCarouselBlockDirective = this;

      const contentBlockCtrl = ctrls[1];
      const currentBlockType = contentBlockCtrl.contentBlock.blockType;

      if (BulbPageService.page.unit.ckeStatus === CKE_STATUS.UPGRADED) {
        $window.addEventListener('addImageToCarousel', (event) => {
          // After receiving the request from CKEditor, we need to give the user the option to add a slide.
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          addImageToCarousel().then((addedImageEntry) => {
            // Add image on the server-side:
            const patch = {
              assetLibraryEntryId: addedImageEntry.assetLibraryEntryId,
              updateAction: 'addImage',
            };

            // Add image on the server side:
            SerialSaveService.save({
              showBusy: true,
              save: () => Restangular.one('units', contentBlockCtrl.page.unit.id)
                .one(CONTENT_EDITOR.BLOCK_PATHS[currentBlockType], event.contentBlock.id)
                .patch(patch)
                .then((response) => {

                  // Update share status to reflect that the page has been edited:
                  const ShareTransition = UnitStateStore.getShareTransitionEnum();
                  UnitStateStore.transitionShareStatus(ShareTransition.EDIT);

                  const customSlideAddedEvent = new CustomEvent('imageCarouselSlideAdded', {
                    detail: {
                      contentBlock: response.contentBlock,
                      page: that.page,
                    },
                  });
                  window.dispatchEvent(customSlideAddedEvent);
                }),
            });
          });
        });
      } else {
        const contentEditorCtrl = ctrls[0];
        const imageCarouselBlockCtrl = ctrls[2];

        element.addClass('bulb-image-carousel');

        const unregisterCarouselRevertHandler = scope.$on('command-carousel-destroy', (event, selectedBlock) => {
          // Only destroy the currently selected content-block
          if (selectedBlock.id === contentBlockCtrl.contentBlock.id) {
            // Display modal to user letting them know they are about to convert the image carousel back to the
            // original image block.
            const modalOptions = {
              titleCode: 'image_carousel_revert_block_form_title',
              bodyCode: 'image_carousel_revert_block_instructions',
              showOkButton: true,
              showCancelButton: true,
            };

            BulbModalService.show(modalOptions).then(() => {
              // Re-create the original image block:
              const uploadImageCarouselBlockDTO = {
                imageCarouselBlockId: selectedBlock.id,
                selectedImageIndex: contentBlockCtrl.contentBlock.displayedImageIndex,
                deleteOriginal: 'true',
              };

              SerialSaveService.save({
                showBusy: true,
                save: () => Restangular.one('units', contentEditorCtrl.page.unit.id).one('revert')
                  .customPOST(uploadImageCarouselBlockDTO, CONTENT_EDITOR.BLOCK_PATHS.IMAGE_CAROUSEL)
                  .then((response) => {
                    contentEditorCtrl.page.unit.contentBlocks[response.contentBlock.id] = response.contentBlock;

                    // update content with new content block information
                    // find placeholder, and replace with content block:
                    const $contentBlockElement = $(`#${selectedBlock.id}`);

                    $contentBlockElement.replaceWith($compile(`<content-block id="${response.contentBlock.id
                    }" contenteditable="false" class="align-center"></content-block>`)(scope));
                    // TODO CLEAN - use a template rather than embedded string.

                    // Emit an 'editableInput' event so that the image block is saved to the page
                    contentEditorCtrl.editor.trigger('editableInput', null, contentEditorCtrl.editor.elements[0]);
                    // Display the correct toolbar for the image-block
                    contentEditorCtrl.updateToolbar();

                    delete contentEditorCtrl.page.unit.contentBlocks[selectedBlock.id];
                    element.removeClass('bulb-image-carousel');
                    // Unregister the carousel destroy handler, so it doesn't get called again
                    // on another call
                    unregisterCarouselRevertHandler();

                    // Update share status to reflect that the page has been edited:
                    const ShareTransition = UnitStateStore.getShareTransitionEnum();
                    UnitStateStore.transitionShareStatus(ShareTransition.EDIT);
                  }),
              });
            });
          }
        });

        scope.$on('command-add-carousel-slide', (event, selectedBlock) => {
          // Only add carousel image to the currently selected image carousel block
          if (selectedBlock.id === contentBlockCtrl.contentBlock.id) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            addImageToCarousel().then((addedImageEntry) => {
              // Add image on the server-side:
              const patch = {
                assetLibraryEntryId: addedImageEntry.assetLibraryEntryId,
                updateAction: 'addImage',
                selectedImageIndex: contentBlockCtrl.contentBlock.displayedImageIndex,
              };
              const index = contentBlockCtrl.contentBlock.displayedImageIndex;

              // Add image on the server side:
              SerialSaveService.save({
                showBusy: true,
                save: () => Restangular.one('units', contentBlockCtrl.page.unit.id)
                  .one(CONTENT_EDITOR.BLOCK_PATHS[currentBlockType], contentBlockCtrl.contentBlock.id)
                  .patch(patch)
                  .then((modifiedImageCarouselBlock) => {
                    // Update share status to reflect that the page has been edited:
                    const ShareTransition = UnitStateStore.getShareTransitionEnum();
                    UnitStateStore.transitionShareStatus(ShareTransition.EDIT);

                    scope.$broadcast('added-carousel-image', index);
                    imageCarouselBlockCtrl.updateCarouselState(modifiedImageCarouselBlock);

                    // Emit an 'editableInput' event so that the new image slide is saved to the page
                    contentEditorCtrl.editor.trigger('editableInput', null, contentEditorCtrl.editor.elements[0]);
                    // This callback function fixes the scrolling issue that would happen after a user adds
                    // an image to the carousel.
                  })
                  .then(() => {
                    // closing picker modal
                    BulbAssetLibraryService.dialog.dismissAllModals();

                    const $pageContent = $('body > .bulb-main').eq(0);
                    $('body').css('overflow', '');
                    $pageContent.css('position', '');
                    $pageContent.css('top', '');
                    $pageContent.css('width', '');
                  }),
              });
            });
          }
        });

        scope.$on('command-remove-carousel-slide', (event, selectedBlock) => {
          // Only remove the image from the currently selected content block
          if (selectedBlock.id === contentBlockCtrl.contentBlock.id) {
            // Modal options that we will display
            let modalOptions;
            if (contentBlockCtrl.contentBlock.carouselImages.length === 1) {
              modalOptions = {
                titleCode: 'image_carousel_delete_slide_form_title',
                bodyCode: 'image_carousel_delete_only_slide_block_instructions',
                showOkButton: true,
                showCancelButton: false,
              };

              BulbModalService.show(modalOptions);
            } else {
              // Display modal to user letting them know they are about to delete the currently selected image
              // carousel
              modalOptions = {
                titleCode: 'image_carousel_delete_slide_form_title',
                bodyCode: 'image_carousel_delete_slide_block_instructions',
                showOkButton: true,
                showCancelButton: true,
              };

              BulbModalService.show(modalOptions).then(() => {
                // Remove image on the server-side:
                const patch = {
                  updateAction: 'removeImage',
                  selectedImageIndex: contentBlockCtrl.contentBlock.displayedImageIndex,
                };
                const index = contentBlockCtrl.contentBlock.displayedImageIndex;

                // Remove image on the server side:
                SerialSaveService.save({
                  showBusy: true,
                  save: () => Restangular.one('units', contentBlockCtrl.page.unit.id)
                    .one(CONTENT_EDITOR.BLOCK_PATHS[currentBlockType], contentBlockCtrl.contentBlock.id)
                    .patch(patch)
                    .then((modifiedImageCarouselBlock) => {
                      // Update share status to reflect that the page has been edited:
                      const ShareTransition = UnitStateStore.getShareTransitionEnum();
                      UnitStateStore.transitionShareStatus(ShareTransition.EDIT);

                      scope.$broadcast('removed-carousel-image', index);
                      imageCarouselBlockCtrl.updateCarouselState(modifiedImageCarouselBlock);

                      // Emit an 'editableInput' event so that the new image slide is saved to the page
                      contentEditorCtrl.editor.trigger('editableInput', null, contentEditorCtrl.editor.elements[0]);
                    }),
                });
              });
            }
          }
        });
      }

      // This function is the asset library helper function that is passed to the showSelectionModal function
      // from the BulbAssetLibraryService. It is actually the callback function for dealing with the selection
      // of an image from the assetLibrary selection modal.
      function imageCarouselSelectHandler(entry) {
        // I am resolving the addCarouselImageDeferred action here so that way the assetLibrary entry image
        // is passed to the command-add-carousel-slide event above.
        // 'that' is actually the context / scope of the 'addImageToCarousel' function defined below.
        // eslint-disable-next-line no-param-reassign
        entry.image.assetLibraryEntryId = entry.id;
        that.addCarouselImageDeferred.resolve(entry.image);
        return that.addCarouselImageDeferred.promise;
      }

      function desktopUploadSelectHandlerFunc() {
        BulbAssetLibraryUploadService.uploadImageBySelectionModal( // from desktop
          that,
          '',
          'submitFileHandler',
          '',
          'doneFileHandler',
          false, // from within assetLibrary
          'pageImageCarousel', // upload state
        );
      }

      function googleImportSelectHandlerFunc() {
        BulbAssetLibraryService.dialog.closeCurrentModal(); // google drive
        BulbAssetLibraryGoogleDriveService.openImageTypePicker((oauthToken, id, mimeType, photoParentId) => {
          BulbBusyCoverService.showBusyDuring(
            BulbAssetLibraryService.api.importFromGoogleDrive(
              oauthToken,
              null,
              id,
              mimeType,
              photoParentId,
            ).then(
              (googleResponseData) => {
                that.doneFileHandler('google-import', googleResponseData);
              },
            ),
          );
        });
      }

      function googlePhotoImportSelectHandlerFunc() {
        BulbAssetLibraryService.dialog.closeCurrentModal();
        BulbAssetLibraryGooglePhotoService.initializeGooglePhotoPicker((oauthToken, mediaId) => {
          BulbBusyCoverService.showBusyDuring(
            BulbAssetLibraryService.api.importFromGooglePhoto(
              oauthToken,
              null,
              mediaId,
            ).then(
              (data) => {
                that.doneFileHandler('google-photo-import', data);
              },
            ),
          );
        });
      }

      // add image to carousel via unsplash.
      function unsplashSelectHandlerFunc() {
        BulbAssetLibraryUnsplashService.initializeUnsplashPhotoPicker((photoId) => {
          BulbBusyCoverService.showBusyDuring(
            BulbAssetLibraryUnsplashService.importFromUnsplash(photoId, null).then(
              (unsplashResponseData) => {
                that.doneFileHandler('unsplash-import', unsplashResponseData);
                BulbAssetLibraryService.dialog.closeCurrentModal();
              },
            ),
          );
        });
      }

      // add images to carousal via OneDrive
      function oneDriveSelectHandlerFunc() {
        BulbAssetLibraryService.dialog.closeCurrentModal();
        BulbAssetLibraryOneDriveService.initializeOneDrivePicker((oneDriveFileObject) => {
          BulbBusyCoverService.showBusyDuring(
            BulbAssetLibraryOneDriveService.importFromOneDrive(oneDriveFileObject.id, null).then(
              (oneDriveResponseData) => {
                that.doneFileHandler('onedrive-import', oneDriveResponseData);
              },
            ),
          );
        }, [CONFIG.image.extensions]);
      }

      this.submitFileHandler = function submitFileHandler(event, data) {
        // eslint-disable-next-line no-param-reassign
        data.showBusyIndicator = BulbBusyService.showBusy();
      };

      this.doneFileHandler = function doneFileHandler(event, data) {
        const entryId = data.entry.id;
        BulbAssetLibraryService.api.getEntry(entryId).then((res) => {
          if (event === 'google-import' || event === 'google-photo-import' || event === 'unsplash-import'
            || event === 'onedrive-import') {
            // What should do, anything?
            $log.debug(`${event}event for image carousel`);
          } else {
            data.showBusyIndicator();
          }
          res.entry.image.assetLibraryEntryId = res.entry.id;
          that.addCarouselImageDeferred.resolve(res.entry.image);
        }, (reason) => {
          $log.error('unable to upload image to carousel form desktop because of reason: ', reason);
        });
      };

      /**
       * This function is used to handle error when file is unable to process.
       */
      this.errorFileHandler = function errorFileHandler(data) {
        data.showBusyIndicator();
      };

      function addImageToCarousel() {
        // This function adds an image to the carousel. The context of this function is quite interesting, in
        // that I give the function its own deferred action within its own scope. I then bind its scope, 'self',
        // to the helper functions so that way, I can resolve the action at a later time, allowing the correct
        // workflow of adding an image to the carousel.
        const self = that;
        self.addCarouselImageDeferred = $q.defer();
        const assetSelectHandler = imageCarouselSelectHandler.bind(self);
        const desktopUploadSelectHandler = desktopUploadSelectHandlerFunc.bind(self);
        const googleImportSelectHandler = googleImportSelectHandlerFunc.bind(self);
        const googlePhotoImportSelectHandler = googlePhotoImportSelectHandlerFunc.bind(self);
        const unsplashSelectHandler = unsplashSelectHandlerFunc.bind(self);
        const oneDriveSelectHandler = oneDriveSelectHandlerFunc.bind(self);
        // The BulbAssetLibraryService showSelectionModal takes callback functions that handle the addition of
        // images. There is a callback function for the assetLibrary, uploading from desktop, google import, and
        // drag and drop.
        BulbAssetLibraryService.dialog.image.showSelectionModal(
          assetSelectHandler,
          desktopUploadSelectHandler,
          googleImportSelectHandler,
          googlePhotoImportSelectHandler,
          unsplashSelectHandler,
          oneDriveSelectHandler,
          BulbAssetLibraryUploadService.createImageUploadOptions( // drag and drop
            null,
            self,
            '',
            'submitFileHandler',
            '',
            'doneFileHandler',
          ),
          true,
        );
        return self.addCarouselImageDeferred.promise;
      }
    },
  };
}
